interface IDefaultParams {
    duration: string;
    country: string;
    category: string;
    tab: string;
}

export const defaultParams: IDefaultParams = {
    duration: "6m",
    country: "999",
    category: "All",
    tab: "0",
};

export const monthIntervals = [1, 3, 6, 12, 25, 37];
export const monthIntervalsShort = [1, 2, 3, 6, 12, 15];
export const monthIntervalsShortForAddOns = [1, 2, 3, 6, 12, 15];
export const weekIntervals = [1, 2, 3];
